export const VALIDATE_SCHEDULE_OTP_CODE_START = 'VALIDATE_SCHEDULE_OTP_CODE_START';

export const VALIDATE_SCHEDULE_OTP_CODE_SUCCESS = 'VALIDATE_SCHEDULE_OTP_CODE_SUCCESS';

export const VALIDATE_SCHEDULE_OTP_CODE_FAILURE = 'VALIDATE_SCHEDULE_OTP_CODE_FAILURE';

export const CLEAR_VALIDATE_SCHEDULE_OTP_CODE_ERROR_MESSAGE = 'CLEAR_VALIDATE_SCHEDULE_OTP_CODE_ERROR_MESSAGE';
